import {local} from 'wix-storage';
import wixLocation from 'wix-location';

$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});

export function button1_click(event) {
	let value  = $w('#input1').value
	if (value === '6630'){
		wixLocation.to('/tnuva-b-content')
	}
}


export function mobileButton1_click(event) {
	local.setItem("bUnlocked", "true");
	wixLocation.to('/tnuva-b-content')
}